"use clients";

import React from "react";
import Image from "next/image";
import emptyImg from "@/images/contacts/empty.webp";
import { useTranslations } from "next-intl";


interface Props {
  isOwner?: boolean;
}

const EmptyContactsHolder: React.FC<Props> = (props) => {
  const t = useTranslations("HiddenFields");
  return (
    <div className="flex flex-col justify-center items-center">
      <p className="text-[#1B1B1B] font-normal text-[18px] tracking-normal text-center align-middle mb-[40px] lg:mb-[54px]">
        {props.isOwner
          ? t("emptyListContacts")
          : t("emptyListContactsDevelopers")}{" "}
        <br />
        {t("tryLaters")}
      </p>
      <div className="relative w-full max-w-[478px] aspect-[478/201] mb-[32px] lg:mb-[45px]">
        <Image
          src={emptyImg}
          alt={t("emptyListContacts")}
          fill
          priority
          sizes="(max-width: 640px) 100vw, 478px"
          className="object-contain"
        />
      </div>
      <p className="text-[#1B1B1B] font-normal text-[18px] tracking-normal text-center align-middle mb-[20px] lg:mb-[34px]">
        {t("noContacts")}
      </p>
    </div>
  );
};

export default EmptyContactsHolder;
